<template>
  <nav class="breadcrumbs" v-if="metaBreadcrumb">
    <ul>
      <template v-for="(breadcrumb, index) in metaBreadcrumb" :key="index">
        <li v-if="breadcrumb.routeName">
          <router-link :to="{ name: breadcrumb.routeName }">
            {{ breadcrumb.i18nLabel ? $t(breadcrumb.i18nLabel) : breadcrumb.label }}
          </router-link>
        </li>

        <li v-else-if="breadcrumb.integrationDropdown">
          <tc-integration-dropdown :integration-dropdown="breadcrumb.integrationDropdown" />
        </li>

        <li v-else-if="breadcrumb.changeBranch && showButtonBranch">
          <button-change-branch />
        </li>
        <li v-else-if="breadcrumb.i18nLabel || breadcrumb.label">
          {{ breadcrumb.i18nLabel ? $t(breadcrumb.i18nLabel) : breadcrumb.label }}
        </li>
      </template>
    </ul>
  </nav>
</template>
<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import TcIntegrationDropdown from '@components/integrations/tc-integration-dropdown.vue';
import buttonChangeBranch from '@components/containers/button-change-branch.vue';
import { useAbility } from '@casl/vue';

const route = useRoute();
const { can } = useAbility();

const showButtonBranch = computed(() => {
  return can('create', 'TmsBranch');
});

const metaBreadcrumb = computed(() => {
  if (typeof route.meta.breadcrumb !== 'function') return null;

  return route.meta.breadcrumb(route);
});
</script>

<style scoped lang="scss">
.breadcrumbs {
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin-left: 0.5rem;
      display: inline;
      font-size: 1.015625rem;
      font-weight: 600;

      &:nth-child(n + 2)::before {
        font-size: 0.6rem;
        padding-right: 0.5rem;
        color: #74788d;
        content: '/';
      }

      a:hover {
        text-decoration: underline !important;
      }
    }
  }
}
</style>
